import React from "react";
import { getStatusLightCircleClassName } from "../utils/statusLightCircle";

export default function StatusLightCircle({ light, withText = false }) {
    return <span className={getStatusLightCircleClassName(light, withText)} role="img" aria-label={`${light.colorName}燈：${light.label}`}>
        {withText ? light.colorName : null}
    </span>;
}
